import { render } from "./addFacilities.vue?vue&type=template&id=6cdd853c&scoped=true"
import script from "./addFacilities.vue?vue&type=script&lang=js"
export * from "./addFacilities.vue?vue&type=script&lang=js"

import "./addFacilities.vue?vue&type=style&index=0&id=6cdd853c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdd853c"]])

export default __exports__